import Emitter from "es6-event-emitter";

/**
 * Contstructs the Resizer
 */
export default class Resizer extends Emitter {
  DOMContainer = null;
  body = null;

  oldAppHeight = null;
  oldAppWidth = window.innerWidth;

  portrait = window.innerWidth < window.innerHeight;

  classNames = [];

  constructor(DOMContainer, classNames) {
    super();
    this.DOMContainer = DOMContainer;
    this.classNames = classNames;
    this.body = document.querySelector("body");
    //css normalize not yet done
    this.body.setAttribute("style", "margin:0;");
    this.setAppHeight();
  }

  afterScroll(scroll) {
    const rect = this.DOMContainer.getBoundingClientRect();
    const height = rect.height;
    let newHeight = height - scroll;
    newHeight = Math.min(newHeight, window.innerHeight);
    this.DOMContainer.setAttribute("style", `height:${newHeight}px;`);
    this.body.scrollIntoView();
    this.checkNewHeight(newHeight);
    this.initListeners();
  }

  checkScroll() {
    const scroll = $(this.body).scrollTop();
    //TODO: sometimes when comig back from 2 tabs it is still old scroll
    if (scroll === 1000) {
      let checkScrollEvt;
      clearTimeout(checkScrollEvt);
      checkScrollEvt = setTimeout(() => {
        this.checkScroll();
      }, 100);
    } else {
      this.afterScroll(scroll);
    }
  }

  checkNewHeight(newHeight) {
    if (newHeight !== this.oldAppHeight) {
      if (this.oldAppHeight) {
        this.oldAppHeight = newHeight;
        this.portrait = window.innerWidth < window.innerHeight;
        this.trigger("resizer:heightChanged");
        if (this.oldAppWidth !== window.innerWidth) {
          this.oldAppWidth = window.innerWidth;
          this.trigger("resizer:rotated");
        }
      } else {
        this.oldAppHeight = newHeight;
      }
    }
  }

  setAppHeight() {
    const newHeight = window.innerHeight;
    //start with full app height
    this.DOMContainer.setAttribute("style", `height:${newHeight}px`);
    //android this is oke? //TODO: device lies checked

    //ios?
    //tag 100 oke (9.3.5) iphone 6
    if (this.classNames.indexOf("TODO") >= 0) {
      $(this.body).scrollTop(1000);
      this.checkScroll(); //FIX for tablets open? //TODO: check
    } else {
      this.checkNewHeight(newHeight);
      $(this.body).scrollTop(0);
      this.initListeners();
    }
  }

  startAppHeight() {
    this.removeListeners();
    //wait untill resizing is really done
    let event;
    clearTimeout(event);
    event = setTimeout(() => {
      this.setAppHeight();
    }, 200);
  }

  onResize = () => {
    this.startAppHeight();
  };

  onFocus = () => {
    // console.log('focus');
    this.startAppHeight();
  };

  onBlur = () => {
    // console.log('blur');
  };

  initListeners() {
    this.initResizeListener();
    this.initFocusListener();
    this.initBlurListener();
  }

  removeListeners() {
    this.removeResizeListener();
    this.removeFocusListener();
    this.removeBlurListener();
  }

  initResizeListener() {
    $(window).on("resize", this.onResize);
  }

  removeResizeListener() {
    $(window).off("resize", this.onResize);
  }

  initFocusListener() {
    $(window).on("focus", this.onFocus);
  }

  removeFocusListener() {
    $(window).off("focus", this.onFocus);
  }

  initBlurListener() {
    $(window).on("blur", this.onBlur);
  }

  removeBlurListener() {
    $(window).off("blur", this.onBlur);
  }
}



// WEBPACK FOOTER //
// ./src/touch/common/components/resizer.js